import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  Observable,
  catchError,
  filter,
  map,
  mergeMap,
  of,
  switchMap,
  takeUntil,
  timer,
  tap,
  withLatestFrom,
} from 'rxjs';

import { Action, Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
  addProperty,
  addPropertyFailure,
  addPropertySuccess,
  addPropertyToWishList,
  addPropertyToWishListFailure,
  addPropertyToWishListSuccess,
  addRegisterAgent,
  addRegisterAgentFailure,
  addRegisterAgentSuccess,
  addTicketReply,
  addTicketReplyFailure,
  addTicketReplySuccess,
  changePassword,
  changePasswordFailure,
  changePasswordSuccess,
  contactAgent,
  contactAgentFailure,
  contactAgentSuccess,
  contactUs,
  contactUsFailure,
  contactUsSuccess,
  createAgentOffMarketProperty,
  createAgentOffMarketPropertyFailure,
  createAgentOffMarketPropertySuccess,
  createAgentPayrollRequest,
  createAgentPayrollRequestFailure,
  createAgentPayrollRequestSuccess,
  createUserPassword,
  createUserPasswordFailure,
  createUserPasswordSuccess,
  createUserTicket,
  createUserTicketFailure,
  createUserTicketSuccess,
  deactivateUser,
  deactivateUserFailure,
  deactivateUserSuccess,
  deleteAgentOffMarketProperty,
  deleteAgentOffMarketPropertyDocument,
  deleteAgentOffMarketPropertyDocumentFailure,
  deleteAgentOffMarketPropertyDocumentSuccess,
  deleteAgentOffMarketPropertyFailure,
  deleteAgentOffMarketPropertySuccess,
  deleteAgentPayrollAttachment,
  deleteAgentPayrollAttachmentFailure,
  deleteAgentPayrollAttachmentSuccess,
  deleteAgentPayrollSubmission,
  deleteAgentPayrollSubmissionFailure,
  deleteAgentPayrollSubmissionSuccess,
  deleteUserProfileImage,
  deleteUserProfileImageFailure,
  deleteUserProfileImageSuccess,
  deleteUserProperty,
  deleteUserPropertyFailure,
  deleteUserPropertySuccess,
  deleteUserTicket,
  deleteUserTicketFailure,
  deleteUserTicketSuccess,
  forgotPassword,
  forgotPasswordFailure,
  forgotPasswordSuccess,
  generateAgentOffMarketPropertyShareLink,
  generateAgentOffMarketPropertyShareLinkFailure,
  generateAgentOffMarketPropertyShareLinkSuccess,
  getAddedPropertyInWishList,
  getAddedPropertyInWishListFailure,
  getAddedPropertyInWishListSuccess,
  getAgentAppointments,
  getAgentAppointmentsFailure,
  getAgentAppointmentsSuccess,
  getAgentById,
  getAgentByIdFailure,
  getAgentByIdSuccess,
  getAgentContactQueries,
  getAgentContactQueriesFailure,
  getAgentContactQueriesSuccess,
  getAgentLeads,
  getAgentLeadsFailure,
  getAgentLeadsSuccess,
  getMarketedAgentLeads,
  getMarketedAgentLeadsSuccess,
  getMarketedAgentLeadsFailure,
  getAgentOffMarketProperties,
  getAgentOffMarketPropertiesFailure,
  getAgentOffMarketPropertiesSuccess,
  getAgentOffMarketPropertyDetails,
  getAgentOffMarketPropertyDetailsFailure,
  getAgentOffMarketPropertyDetailsSuccess,
  getAgentPayrollSubmissionDetails,
  getAgentPayrollSubmissionDetailsFailure,
  getAgentPayrollSubmissionDetailsSuccess,
  getAgentPayrollSubmissions,
  getAgentPayrollSubmissionsFailure,
  getAgentPayrollSubmissionsSuccess,
  getAgentPortfolio,
  getAgentPortfolioFailure,
  getAgentPortfolioSuccess,
  getAllRegisterAgents,
  getAllRegisterAgentsFailure,
  getAllRegisterAgentsSuccess,
  getBlogById,
  getBlogByIdFailure,
  getBlogByIdSuccess,
  getBlogs,
  getBlogsFailure,
  getBlogsSuccess,
  getMapProperties,
  getMapPropertiesFailure,
  getMapPropertiesSuccess,
  getMessages,
  getMessagesFailure,
  getMessagesList,
  getMessagesListFailure,
  getMessagesListSuccess,
  getMessagesSuccess,
  getMlsPropertyDetails,
  getMlsPropertyDetailsFailure,
  getMlsPropertyDetailsSuccess,
  getPropertyDetailsFailure,
  getPropertyDetailsSuccess,
  getSharedOffMarketProperty,
  getSharedOffMarketPropertyFailure,
  getSharedOffMarketPropertySuccess,
  getTicketDetails,
  getTicketDetailsFailure,
  getTicketDetailsSuccess,
  getTicketReplies,
  getTicketRepliesFailure,
  getTicketRepliesSuccess,
  getTwitterPosts,
  getTwitterPostsFailure,
  getTwitterPostsSuccess,
  getInstagramPosts,
  getInstagramPostsFailure,
  getInstagramPostsSuccess,
  getUserById,
  getUserByIdFailure,
  getUserByIdSuccess,
  getUserDetails,
  getUserDetailsFailure,
  getUserDetailsSuccess,
  getUserProperties,
  getUserPropertiesFailure,
  getUserPropertiesSuccess,
  getUserPropertyDetails,
  getUserScheduledTours,
  getUserScheduledToursFailure,
  getUserScheduledToursSuccess,
  getUserTickets,
  getUserTicketsFailure,
  getUserTicketsSuccess,
  getUserWishlist,
  getUserWishlistFailure,
  getUserWishlistSuccess,
  getYoutubeVideos,
  getYoutubeVideosFailure,
  getYoutubeVideosSuccess,
  login,
  loginFailure,
  loginSuccess,
  initiateMarketedListingPayment,
  initiateMarketedListingPaymentFailure,
  initiateMarketedListingPaymentSuccess,
  newsletterSubscribe,
  newsletterSubscribeFailure,
  newsletterSubscribeSuccess,
  removePropertyFromWishList,
  removePropertyFromWishListFailure,
  removePropertyFromWishListSuccess,
  resetContactForm,
  resetPassword,
  resetPasswordFailure,
  resetPasswordSuccess,
  scheduleATour,
  scheduleATourFailure,
  scheduleATourSuccess,
  scheduleMarketedPropertyTour,
  scheduleMarketedPropertyTourSuccess,
  scheduleMarketedPropertyTourFailure,
  searchProperties,
  searchPropertiesFailure,
  searchPropertiesSuccess,
  sendMessage,
  sendMessageFailure,
  sendMessageSuccess,
  signUp,
  signUpFailure,
  signUpSuccess,
  submitPropertyForApproval,
  submitPropertyForApprovalFailure,
  submitPropertyForApprovalSuccess,
  updateAgentAppointmentStatus,
  updateAgentAppointmentStatusFailure,
  updateAgentAppointmentStatusSuccess,
  updateAgentLeadStatus,
  updateAgentLeadStatusFailure,
  updateAgentLeadStatusSuccess,
  updateAgentOffMarketProperty,
  updateAgentOffMarketPropertyFailure,
  updateAgentOffMarketPropertySuccess,
  updateAgentPayrollRequest,
  updateAgentPayrollRequestFailure,
  updateAgentPayrollRequestSuccess,
  updateAgentPortfolio,
  updateAgentPortfolioFailure,
  updateAgentPortfolioSuccess,
  updateUserProfileDetails,
  updateUserProfileDetailsFailure,
  updateUserProfileDetailsSuccess,
  updateUserProfileImage,
  updateUserProfileImageFailure,
  updateUserProfileImageSuccess,
  updateUserTicketStatus,
  updateUserTicketStatusFailure,
  updateUserTicketStatusSuccess,
  uploadAgentOffMarketPropertyDocuments,
  uploadAgentOffMarketPropertyDocumentsFailure,
  uploadAgentOffMarketPropertyDocumentsSuccess,
  uploadAgentPayrollDocuments,
  uploadAgentPayrollDocumentsFailure,
  uploadAgentPayrollDocumentsSuccess,
  verifyEmailOtp,
  verifyEmailOtpFailure,
  verifyEmailOtpSuccess,
  createOrUpdateRentalListing,
  createOrUpdateRentalListingFailure,
  createOrUpdateRentalListingSuccess,
  deleteRentalListing,
  deleteRentalListingFailure,
  deleteRentalListingSuccess,
  getRentalListingById,
  getRentalListingByIdFailure,
  getRentalListingByIdSuccess,
  getRentalListings,
  getRentalListingsFailure,
  getRentalListingsSuccess,
  searchRentalProperties,
  searchRentalPropertiesFailure,
  searchRentalPropertiesSuccess,
  getRentalMapMarkers,
  getRentalMapMarkersFailure,
  getRentalMapMarkersSuccess,
  submitRentalForApproval,
  submitRentalForApprovalFailure,
  submitRentalForApprovalSuccess,
  getArisMarketedPropertiesFailure,
  getArisMarketedProperties,
  getArisMarketedPropertiesSuccess,
  getArisMarketedMapProperties,
  getArisMarketedMapPropertiesFailure,
  getArisMarketedMapPropertiesSuccess,
  getArisMarketedPropertyDetails,
  getArisMarketedPropertyDetailsFailure,
  getArisMarketedPropertyDetailsSuccess,
  getPublicRentalListingByIdFailure,
  getPublicRentalListingByIdSuccess,
  getPublicRentalListingById,
  startKycIdentitySession,
  startKycProfilePolling,
  startKycIdentitySessionFailure,
  startKycIdentitySessionSuccess,
  checkKycProfileStatus,
  checkKycProfileStatusSuccess,
  checkKycProfileStatusFailure,
  stopKycProfilePolling,
  kycProfilePollingTimedOut,
  clearKycProfilePollingState,
  markAsSold,
  markAsSoldSuccess,
  markAsSoldFailure,
} from './actions';
import { AuthServiceAris } from 'src/app/services/auth/auth.service';
import { AuthFacadeService } from 'src/app/services/auth/auth-facade.service';
import { CustomSnackbarComponent } from 'src/app/shared/components/custom-snackbar/custom-snackbar.component';
import {
  ExtendedBaseInterface,
  KycIdentitySessionResponse,
  ListingPaymentInitiateResponse,
  MarketedPropertyListing,
  Roles,
} from 'src/app/shared/models';
import { Routes } from 'src/app/shared/routes/routes';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user/user.service';
import { RentalService } from 'src/app/services/rental.services';
import { setSharedData } from '../shared-store/actions';
import { scrollToTop } from 'src/app/shared/utils';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';
// Import from '/pure' so merely importing this module does NOT inject the
// Stripe.js <script>. The default '@stripe/stripe-js' entry auto-injects on
// import; because this effects module is eagerly loaded, that pulled Stripe.js
// (and its perpetual telemetry setInterval timers) onto every page, keeping
// Zone.js unstable and blocking Angular hydration (NG0506). With '/pure',
// Stripe.js is only injected when loadStripe() is actually called (payment/KYC
// flows, which are CSR-only and not hydrated).
import { loadStripe } from '@stripe/stripe-js/pure';
import { selectPendingRentalSubmitAfterKycId } from './selectors';
import { BrowserStorageService } from 'src/app/shared/utils/browser-storage.service';
import { WINDOW } from 'src/app/shared/utils/browser-globals';
@Injectable()
export class UserStoreEffects {
  roles = Roles;
  routes = Routes;
  modalService = inject(NgbModal);
  storage = inject(BrowserStorageService);
  window = inject(WINDOW, { optional: true });
  constructor(
    private actions$: Actions,
    private store: Store,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthServiceAris,
    private authFacade: AuthFacadeService,
    private userService: UserService,
    private rentalService: RentalService,
    private clipboard: Clipboard,
  ) {}

  signUpUserEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(signUp),
      switchMap((action) =>
        this.authService.signUp(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `User registered successfully`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
              this.authFacade.pendingEmail$.next(action.data.email);
              //optional check for auto login after signup
              this.storage.set('accessToken', result.result?.['token']);
              // this.router.navigate(['auth', 'email-otp']);
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => {
            return [getUserDetails(), signUpSuccess({ data: res })];
          }),
          catchError((error) => {
            return of(signUpFailure({ error }));
          }),
        ),
      ),
    );
  });

  forgotPasswordEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(forgotPassword),
      switchMap((action) =>
        this.authService.forgotPassword(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Email with reset password link sent successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => {
            return [forgotPasswordSuccess({ data: res })];
          }),
          catchError((error) => {
            return of(forgotPasswordFailure({ error }));
          }),
        ),
      ),
    );
  });

  resetPasswordEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(resetPassword),
      switchMap((action) =>
        this.authService.resetPassword(action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Password has been successfully reset.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
              this.router.navigate(['auth', 'signin']);
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          map((res) => resetPasswordSuccess()),
          catchError((error) => {
            return of(resetPasswordFailure({ error }));
          }),
        ),
      ),
    );
  });

  loginUserEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(login),
      switchMap((action) =>
        this.authService.login(action.payload).pipe(
          tap((result) => {
            if (result.successful && result.result?.isAuthSuccessful) {
              this.storage.set('accessToken', result.result.token);
            } else {
              if (
                result.successful &&
                result.message.includes('verification link')
              ) {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `${result.message}`,
                    type: 'success',
                  },
                  panelClass: 'success',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
                this.authFacade.pendingEmail$.next(action.payload.email);
                this.router.navigate(['auth', 'email-otp']);
              } else {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `${result.message}`,
                    type: 'danger',
                  },
                  panelClass: 'danger',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
                return;
              }
            }
          }),
          mergeMap((res) => {
            if (res.successful && res.result.isAuthSuccessful) {
              return [getUserDetails(), loginSuccess()];
            } else {
              return [loginFailure({ error: res.message })];
            }
          }),
          catchError((error) => {
            return of(loginFailure({ error }));
          }),
        ),
      ),
    );
  });

  getUserDetailsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserDetails),
      switchMap((action) =>
        this.authService.getUser().pipe(
          tap((result) => {
            if (result.successful) {
              this.storage.set('role', JSON.stringify(result.result.role));
              if (
                this.router.url.includes('auth/signin') ||
                this.router.url.includes('auth/signup') ||
                this.router.url.includes('auth/email-otp')
              ) {
                const returnUrl =
                  this.router.parseUrl(this.router.url).queryParams[
                    'returnUrl'
                  ];
                if (returnUrl) {
                  this.router.navigateByUrl(returnUrl);
                } else if (result.result.role === this.roles.User) {
                  this.router.navigate(['user', 'info'], {});
                } else {
                  this.router.navigate(['agent', 'dashboard'], {});
                }
              }
            }
          }),
          mergeMap((res) => [getUserDetailsSuccess({ payload: res.result })]),
          catchError((error) => {
            this.snackBar.openFromComponent(CustomSnackbarComponent, {
              data: {
                title: `Auth failed please login again`,
                type: 'danger',
              },
              panelClass: 'danger',
              duration: 5000,
              horizontalPosition: 'start',
            });
            this.authFacade.signOut();
            this.router.navigate(['auth', 'signin']);
            return of(getUserDetailsFailure({ error }));
          }),
        ),
      ),
    );
  });

  verifyEmailOtpEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(verifyEmailOtp),
      switchMap((action) =>
        this.authService.verifyUserEmailOtp(action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              if (
                result.message ===
                'Email verified. Please wait for your account confirmation.'
              ) {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `${result.message}`,
                    type: 'success',
                  },
                  panelClass: 'success',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
                this.router.navigate(['auth', 'signin']);
              } else {
                this.storage.set('accessToken', result.result['token']);
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `OTP verified successfully.`,
                    type: 'success',
                  },
                  panelClass: 'success',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
              }
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => {
            if (res.successful) {
              if (
                res.message !==
                'Email verified. Please wait for your account confirmation.'
              ) {
                return [verifyEmailOtpSuccess(), getUserDetails()];
              } else {
                return [verifyEmailOtpSuccess()];
              }
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${res.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
              return [verifyEmailOtpFailure({ error: res.message })];
            }
          }),
          catchError((error) => {
            return of(verifyEmailOtpFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateUserProfileDetailsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateUserProfileDetails),
      switchMap((action) =>
        this.authService.updateUserProfileDetails(action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Profile updated successfully`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            updateUserProfileDetailsSuccess({ payload: res.result }),
            getUserDetails(),
          ]),
          catchError((error) => {
            return of(updateUserProfileDetailsFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateUserProfileImageEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateUserProfileImage),
      switchMap((action) =>
        this.authService.updateUserProfileImage(action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Profile image updated successfully`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => {
            return [
              updateUserProfileImageSuccess({ payload: res.result }),
              getUserDetails(),
            ];
          }),
          catchError((error) => {
            return of(updateUserProfileImageFailure({ error }));
          }),
        ),
      ),
    );
  });

  deleteUserProfileImageEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteUserProfileImage),
      switchMap((action) =>
        this.authService.deleteUserProfileImage().pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Profile image deleted successfully`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => {
            return [deleteUserProfileImageSuccess(), getUserDetails()];
          }),
          catchError((error) => {
            return of(deleteUserProfileImageFailure({ error }));
          }),
        ),
      ),
    );
  });

  deactivateUserEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deactivateUser),
      switchMap((action) =>
        this.authService.deactivateUser(action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `User deleted successfully`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
              this.modalService.dismissAll();
              this.authFacade.signOut();

              // Force hard reload to home to ensure all states are cleared
              if (this.window) {
                this.window.location.href = '/';
              }
            } else {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `${result.message}`,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          map((res) => deactivateUserSuccess()),
          catchError((error) => {
            return of(deactivateUserFailure({ error }));
          }),
        ),
      ),
    );
  });

  createUserPasswordEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(createUserPassword),
      withLatestFrom(this.authFacade.userDetails$),
      switchMap(([action, userDetails]) =>
        this.authService
          .createUserPassword({ ...action.data, email: userDetails.email })
          .pipe(
            tap((result) => {
              if (result.successful) {
                this.modalService.dismissAll();
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `Password created successfully`,
                    type: 'success',
                  },
                  panelClass: 'success',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
              } else {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `${result.message}`,
                    type: 'danger',
                  },
                  panelClass: 'danger',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
              }
            }),
            mergeMap((res) => {
              return [
                createUserPasswordSuccess({ data: res }),
                getUserDetails(),
              ];
            }),
            catchError((error) => {
              return of(createUserPasswordFailure({ error }));
            }),
          ),
      ),
    );
  });

  changePasswordEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(changePassword),
      withLatestFrom(this.authFacade.userDetails$),
      switchMap(([action, userDetails]) =>
        this.authService
          .changePassword({ ...action.data, email: userDetails.email })
          .pipe(
            tap((result) => {
              if (result.successful) {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `Password changed successfully.`,
                    type: 'success',
                  },
                  panelClass: 'success',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
                this.modalService.dismissAll();
                this.router.navigate(['auth', 'signin']);
                this.authFacade.signOut();
              } else {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `${result.message}`,
                    type: 'danger',
                  },
                  panelClass: 'danger',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
              }
            }),
            map((res) => changePasswordSuccess({ data: res })),
            catchError((error) => {
              return of(changePasswordFailure({ error }));
            }),
          ),
      ),
    );
  });

  getUserPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserProperties),
      switchMap((action) =>
        this.userService.getMarketedProperties(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              // something
            }
          }),
          mergeMap((res) => [
            getUserPropertiesSuccess({ data: res }),
            setSharedData({ data: res as ExtendedBaseInterface }),
          ]),
          catchError((error) => {
            return of(getUserPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });

  getMapPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMapProperties),
      switchMap((action) =>
        this.userService.getMapProperties(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              // something
            }
          }),
          mergeMap((res) => [getMapPropertiesSuccess({ data: res })]),
          catchError((error) => {
            return of(getMapPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });

  getUserWishlistEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserWishlist),
      switchMap((action) =>
        this.userService.getUserWishList(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              // something
            }
          }),
          mergeMap((res) => [
            getUserWishlistSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getUserWishlistFailure({ error }));
          }),
        ),
      ),
    );
  });

  addPropertyToWishListEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(addPropertyToWishList),
      switchMap((action) =>
        this.userService.addPropertyToWishList(action.listingKey).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Successfully added to Wishlist.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            addPropertyToWishListSuccess({ data: res }),
            getAddedPropertyInWishList(),
          ]),
          catchError((error) => {
            return of(addPropertyToWishListFailure({ error }));
          }),
        ),
      ),
    );
  });

  removePropertyFromWishListEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(removePropertyFromWishList),
      switchMap((action) =>
        this.userService.removePropertyFromWishList(action.listingKey).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Successfully removed from Wishlist.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            removePropertyFromWishListSuccess({ data: res }),
            getUserWishlist({ data: action.data }),
            getAddedPropertyInWishList(),
          ]),
          catchError((error) => {
            return of(removePropertyFromWishListFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAddedPropertyInWishlistEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAddedPropertyInWishList),
      switchMap((action) =>
        this.userService.getAddedPropertyInWishList().pipe(
          tap((result) => {
            if (result.successful) {
              // something
            }
          }),
          mergeMap((res) => [getAddedPropertyInWishListSuccess({ data: res })]),
          catchError((error) => {
            return of(getAddedPropertyInWishListFailure({ error }));
          }),
        ),
      ),
    );
  });

  addUserPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(addProperty),
      switchMap((action) =>
        this.userService.addMarketedProperty(action.data).pipe(
          tap((result) => {
            if (result) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Successfully ${
                    action?.check === 'draft'
                      ? 'saved as draft.'
                      : 'added a property.'
                  }`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
            this.router.navigate(['user', 'properties'], {
              replaceUrl: true,
            });
          }),
          mergeMap((res) => [
            addPropertySuccess({ data: res }),
            ...(action?.check === 'submit'
              ? [submitPropertyForApproval({ id: res.id })]
              : []),
          ]),
          catchError((error) => {
            return of(addPropertyFailure({ error }));
          }),
        ),
      ),
    );
  });

  submitPropertyForApprovalEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(submitPropertyForApproval),
      switchMap((action) =>
        this.userService.submitPropertyForApproval(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Property submitted for approval successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
              this.router.navigate(['user', 'properties'], {
                replaceUrl: true,
              });
            }
          }),
          mergeMap((res) => [submitPropertyForApprovalSuccess({ data: res })]),
          catchError((error) => {
            return of(submitPropertyForApprovalFailure({ error }));
          }),
        ),
      ),
    );
  });

  deleteUserPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteUserProperty),
      switchMap((action) =>
        this.userService.removeUserProperty(action.propertyId).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Successfully deleted property.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            deleteUserPropertySuccess({ data: res }),
            getUserProperties({ data: action.data }),
          ]),
          catchError((error) => {
            return of(deleteUserPropertyFailure({ error }));
          }),
        ),
      ),
    );
  });

  markAsSoldEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(markAsSold),
      switchMap((action) =>
        this.userService.markAsSold(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Property marked as sold successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            markAsSoldSuccess({ data: res }),
            getMarketedAgentLeads({ data: action.data }),
          ]),
          catchError((error) => {
            return of(markAsSoldFailure({ error }));
          }),
        ),
      ),
    );
  });

  initiateMarketedListingPaymentEffect$: Observable<Action> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(initiateMarketedListingPayment),
        switchMap((action) =>
          this.userService.initiateMarketedListingPayment(action.data).pipe(
            tap(async (result) => {
              if (!result?.successful) {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: result?.message || 'Unable to initiate payment.',
                    type: 'danger',
                  },
                  panelClass: 'danger',
                  duration: 5000,
                  horizontalPosition: 'start',
                });
                return;
              }

              const paymentResult =
                (result as ListingPaymentInitiateResponse).result || {};

              if (action.data.paymentMethod === 'stripe') {
                const sessionId =
                  paymentResult.stripeSessionId || paymentResult.id;
                if (sessionId) {
                  const stripe = await loadStripe(
                    environment.stripePublishableKey,
                  );
                  if (stripe) {
                    await stripe.redirectToCheckout({ sessionId });
                    return;
                  }
                }
              }

              const redirectUrl =
                paymentResult.redirectUrl ||
                paymentResult.checkoutUrl ||
                paymentResult.approvalUrl ||
                paymentResult.url ||
                paymentResult.stripeSessionUrl ||
                paymentResult.payPalApprovalUrl;

              if (redirectUrl) {
                if (this.window) {
                  this.window.location.href = redirectUrl;
                }
                return;
              }

              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title:
                    'Payment initialized but redirect URL was not provided.',
                  type: 'warning',
                },
                panelClass: 'warning',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }),
            map((res) => initiateMarketedListingPaymentSuccess({ data: res })),
            catchError((error) =>
              of(initiateMarketedListingPaymentFailure({ error })),
            ),
          ),
        ),
      );
    },
  );

  startKycIdentitySessionEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(startKycIdentitySession),
      switchMap(() =>
        this.userService.startKycIdentitySession().pipe(
          tap(async (result) => {
            if (!result?.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: result?.message || 'Unable to start KYC verification.',
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
              return;
            }

            const clientSecret = (result as KycIdentitySessionResponse).result
              ?.clientSecret;

            if (!clientSecret) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title:
                    'KYC session was created, but client secret is missing.',
                  type: 'warning',
                },
                panelClass: 'warning',
                duration: 5000,
                horizontalPosition: 'start',
              });
              return;
            }

            const stripe = await loadStripe(environment.stripePublishableKey);
            if (!stripe) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: 'Unable to initialize Stripe for KYC verification.',
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
              return;
            }

            const verificationResult =
              await stripe.verifyIdentity(clientSecret);
            if (verificationResult.error?.message) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: verificationResult.error.message,
                  type: 'danger',
                },
                panelClass: 'danger',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            startKycIdentitySessionSuccess({ data: res }),
            clearKycProfilePollingState(),
            startKycProfilePolling(),
          ]),
          catchError((error) => of(startKycIdentitySessionFailure({ error }))),
        ),
      ),
    );
  });

  startKycProfilePollingEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(startKycProfilePolling),
      switchMap(() =>
        timer(0, 5000).pipe(
          map((attempt) => checkKycProfileStatus({ attempt: attempt + 1 })),
          takeUntil(
            this.actions$.pipe(
              ofType(stopKycProfilePolling, kycProfilePollingTimedOut),
            ),
          ),
        ),
      ),
    );
  });

  kycProfilePollingTimeoutEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(startKycProfilePolling),
      switchMap(() =>
        timer(120000).pipe(
          map(() => kycProfilePollingTimedOut()),
          takeUntil(this.actions$.pipe(ofType(stopKycProfilePolling))),
        ),
      ),
    );
  });

  checkKycProfileStatusEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(checkKycProfileStatus),
      switchMap(() =>
        this.authService.getUser().pipe(
          mergeMap((res) => {
            const details = res?.result;
            const kycCompleted = Boolean(details?.kycCompleted);
            const kycStatus = details?.kycStatus?.trim() || null;
            const shouldStopPolling =
              kycCompleted || (!!kycStatus && !kycCompleted);

            const actions: Action[] = [
              getUserDetailsSuccess({ payload: details }),
              checkKycProfileStatusSuccess({ kycCompleted, kycStatus }),
            ];

            if (shouldStopPolling) {
              actions.push(stopKycProfilePolling());
            }

            return actions;
          }),
          catchError((error) => of(checkKycProfileStatusFailure({ error }))),
        ),
      ),
    );
  });

  kycProfilePollingTimeoutNotificationEffect$: Observable<Action> =
    createEffect(() => {
      return this.actions$.pipe(
        ofType(kycProfilePollingTimedOut),
        tap(() => {
          this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data: {
              title:
                'KYC status is still in review. Please refresh status or try again shortly.',
              type: 'warning',
            },
            panelClass: 'warning',
            duration: 5000,
            horizontalPosition: 'start',
          });
        }),
        map(() => stopKycProfilePolling()),
      );
    });

  submitPendingRentalAfterKycEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(checkKycProfileStatusSuccess),
      filter((action) => action.kycCompleted),
      withLatestFrom(this.store.select(selectPendingRentalSubmitAfterKycId)),
      filter(([, pendingId]) => Boolean(pendingId)),
      map(([, pendingId]) =>
        submitRentalForApproval({ id: pendingId as number }),
      ),
    );
  });
  getPropertyDetailsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserPropertyDetails),
      switchMap((action) => {
        if (action.propertyId === undefined || action.propertyId === null) {
          return of(
            getPropertyDetailsFailure({ error: 'Invalid property ID' }),
          );
        }
        return this.userService.getUserPropertyDetails(action.propertyId).pipe(
          tap((result) => {
            if (result) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Successfully fetched property details.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          map((res) =>
            getPropertyDetailsSuccess({
              data: res.result as MarketedPropertyListing,
            }),
          ),
          catchError((error) => of(getPropertyDetailsFailure({ error }))),
        );
      }),
    );
  });

  getArisMarketedPropertyDetailsEffect$: Observable<Action> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(getArisMarketedPropertyDetails),
        switchMap((action) => {
          if (action.propertyId === undefined || action.propertyId === null) {
            return of(
              getArisMarketedPropertyDetailsFailure({
                error: 'Invalid property ID',
              }),
            );
          }
          return this.userService
            .getArisMarketedPropertyDetails(action.propertyId)
            .pipe(
              tap((result) => {
                if (result) {
                  this.snackBar.openFromComponent(CustomSnackbarComponent, {
                    data: {
                      title: `Successfully fetched Aris marketed property details.`,
                      type: 'success',
                    },
                    panelClass: 'success',
                    duration: 5000,
                    horizontalPosition: 'start',
                  });
                }
              }),
              map((res) =>
                getArisMarketedPropertyDetailsSuccess({
                  data: res.result as MarketedPropertyListing,
                }),
              ),
              catchError((error) =>
                of(getArisMarketedPropertyDetailsFailure({ error })),
              ),
            );
        }),
      );
    },
  );

  getUserTicketsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserTickets),
      switchMap((action) =>
        this.userService.getUserTickets(action.data, action.role).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            getUserTicketsSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getUserTicketsFailure({ error }));
          }),
        ),
      ),
    );
  });

  createUserTicketEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(createUserTicket),
      switchMap((action) =>
        this.userService.createUserTicket(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              // this.dialog.closeAll();
            }
          }),
          mergeMap((res) => [createUserTicketSuccess({ data: res })]),
          catchError((error) => {
            return of(createUserTicketFailure({ error }));
          }),
        ),
      ),
    );
  });

  deleteUserTicketEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteUserTicket),
      switchMap((action) =>
        this.userService.deleteUserTicket(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Deleted successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [deleteUserTicketSuccess({ data: res })]),
          catchError((error) => {
            return of(deleteUserTicketFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateUserTicketStatusEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateUserTicketStatus),
      switchMap((action) =>
        this.userService.updateUserTicketStatus(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Ticket status updated successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            updateUserTicketStatusSuccess({ data: res }),
            getUserTickets({ data: action.data, role: action.role }),
          ]),
          catchError((error) => {
            return of(updateUserTicketStatusFailure({ error }));
          }),
        ),
      ),
    );
  });

  getTicketDetailsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getTicketDetails),
      switchMap((action) =>
        this.userService.getTicketDetails(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            getTicketDetailsSuccess({ data: res }),
            getTicketReplies({ id: action.id }),
          ]),
          catchError((error) => {
            return of(getTicketDetailsFailure({ error }));
          }),
        ),
      ),
    );
  });

  getTicketRepliesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getTicketReplies),
      switchMap((action) =>
        this.userService.getTicketReplies(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [getTicketRepliesSuccess({ data: res })]),
          catchError((error) => {
            return of(getTicketRepliesFailure({ error }));
          }),
        ),
      ),
    );
  });

  addTicketReplyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(addTicketReply),
      switchMap((action) =>
        this.userService.addTicketReply(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Reply added successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            addTicketReplySuccess({ data: res }),
            getTicketReplies({ id: action.data.ticketId }),
          ]),
          catchError((error) => {
            return of(addTicketReplyFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentLeadsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAgentLeads),
      switchMap((action) =>
        this.userService.getAgentLeads(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            getAgentLeadsSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getAgentLeadsFailure({ error }));
          }),
        ),
      ),
    );
  });

  getMarketedAgentLeadsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMarketedAgentLeads),
      switchMap((action) =>
        this.userService.getMarketedAgentLeads(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            getMarketedAgentLeadsSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getMarketedAgentLeadsFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateAgentLeadStatusEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateAgentLeadStatus),
      switchMap((action) =>
        this.userService.updateAgentLeadStatus(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Lead status updated successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            updateAgentLeadStatusSuccess({ data: res }),
            getAgentLeads({ data: action.data }),
          ]),
          catchError((error) => {
            return of(updateAgentLeadStatusFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentAppointmentsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAgentAppointments),
      switchMap((action) =>
        this.userService.getAgentAppointments(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            getAgentAppointmentsSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getAgentAppointmentsFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateAgentAppointmentStatusEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateAgentAppointmentStatus),
      switchMap((action) =>
        this.userService.updateAgentAppointmentStatus(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Appointment status updated successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            updateAgentAppointmentStatusSuccess({ data: res }),
            getAgentAppointments({ data: action.data }),
          ]),
          catchError((error) => {
            return of(updateAgentAppointmentStatusFailure({ error }));
          }),
        ),
      ),
    );
  });

  searchPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(searchProperties),
      switchMap((action) =>
        this.userService.searchMlsProperties(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            searchPropertiesSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(searchPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });

  getMlsPropertyDetailsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMlsPropertyDetails),
      switchMap((action) =>
        this.userService.getMlsPropertyDetails(action.propertyId).pipe(
          tap((result) => {
            //
          }),
          mergeMap((res) => [getMlsPropertyDetailsSuccess({ data: res })]),
          catchError((error) => {
            return of(getMlsPropertyDetailsFailure({ error }));
          }),
        ),
      ),
    );
  });

  scheduleATourEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(scheduleATour),
      switchMap((action) =>
        this.userService.scheduleATour(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Tour scheduled successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [scheduleATourSuccess({ data: res })]),
          catchError((error) => {
            return of(scheduleATourFailure({ error }));
          }),
        ),
      ),
    );
  });

  scheduleMarketedPropertyTourEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(scheduleMarketedPropertyTour),
      switchMap((action) =>
        this.userService.scheduleMarketedPropertyTour(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Tour request submitted successfully!`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [scheduleMarketedPropertyTourSuccess({ data: res })]),
          catchError((error) => {
            return of(scheduleMarketedPropertyTourFailure({ error }));
          }),
        ),
      ),
    );
  });

  contactUsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(contactUs),
      switchMap((action) =>
        this.userService.contactUs(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Thank you! An Aris agent will contact you soon.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            contactUsSuccess({ data: res }),
            resetContactForm(),
          ]),
          catchError((error) => {
            return of(contactUsFailure({ error }));
          }),
        ),
      ),
    );
  });

  getUserScheduledToursEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserScheduledTours),
      switchMap((action) =>
        this.userService.getUserScheduledTours(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            getUserScheduledToursSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getUserScheduledToursFailure({ error }));
          }),
        ),
      ),
    );
  });

  getMessagesListEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMessagesList),
      switchMap((action) =>
        this.userService.getMessagesList(action.userId).pipe(
          tap((result) => {
            //
          }),
          map((res) => getMessagesListSuccess({ data: res })),
          catchError((error) => {
            return of(getMessagesListFailure({ error }));
          }),
        ),
      ),
    );
  });

  getMessagesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMessages),
      switchMap((action) =>
        this.userService.getMessages(action.payload).pipe(
          tap((result) => {
            //
          }),
          map((res) => getMessagesSuccess({ data: res })),
          catchError((error) => {
            return of(getMessagesFailure({ error }));
          }),
        ),
      ),
    );
  });

  sendMessageEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(sendMessage),
      switchMap((action) =>
        this.userService.sendMessage(action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            sendMessageSuccess({ data: res }),
            getMessages({
              payload: {
                senderId: action.payload.senderId.toString(),
                recieverId: action.payload.receiverId.toString(),
              },
            }),
          ]),
          catchError((error) => {
            return of(sendMessageFailure({ error }));
          }),
        ),
      ),
    );
  });

  getUserByIdEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserById),
      switchMap((action) =>
        this.userService.getUserById(action.userId).pipe(
          tap((result) => {
            //
          }),
          map((res) => getUserByIdSuccess({ data: res })),
          catchError((error) => {
            return of(getUserByIdFailure({ error }));
          }),
        ),
      ),
    );
  });

  getBlogsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getBlogs),
      switchMap((action) =>
        this.userService.getBlogs(action.data).pipe(
          tap((result) => {
            //
          }),
          map((res) => getBlogsSuccess({ data: res })),
          catchError((error) => {
            return of(getBlogsFailure({ error }));
          }),
        ),
      ),
    );
  });

  getBlogByIdEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getBlogById),
      switchMap((action) =>
        this.userService.getBlogById(action.blogId).pipe(
          tap((result) => {
            //
          }),
          map((res) => getBlogByIdSuccess({ data: res })),
          catchError((error) => {
            return of(getBlogByIdFailure({ error }));
          }),
        ),
      ),
    );
  });

  registerAgentEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(addRegisterAgent),
      switchMap((action) =>
        this.userService.registerAgent(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Agent registration request sent successfully, Please wait for admin approval notify you by mail.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          tap(() => this.router.navigate(['/'])),
          mergeMap((res) => [addRegisterAgentSuccess({ data: res })]),
          catchError((error) => {
            return of(addRegisterAgentFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAllRegisteredAgentsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAllRegisterAgents),
      switchMap((action) =>
        this.userService.getAllRegisterAgents(action.data).pipe(
          tap((result) => {
            //
          }),
          map((res) => getAllRegisterAgentsSuccess({ data: res })),
          catchError((error) => {
            return of(getAllRegisterAgentsFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentByIdEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAgentById),
      switchMap((action) =>
        this.userService.getAgentById(action.agentId).pipe(
          tap((result) => {
            //
          }),
          map((res) => getAgentByIdSuccess({ data: res })),
          catchError((error) => {
            return of(getAgentByIdFailure({ error }));
          }),
        ),
      ),
    );
  });

  getYoutubeVideosEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getYoutubeVideos),
      switchMap((action) =>
        this.userService.getYoutubeVideos(action.max).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [getYoutubeVideosSuccess({ data: res })]),
          catchError((error) => {
            return of(getYoutubeVideosFailure({ error }));
          }),
        ),
      ),
    );
  });

  getTwitterPostsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getTwitterPosts),
      switchMap((action) =>
        this.userService.getTwitterPosts(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [getTwitterPostsSuccess({ data: res })]),
          catchError((error) => {
            return of(getTwitterPostsFailure({ error }));
          }),
        ),
      ),
    );
  });

  getInstagramPostsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getInstagramPosts),
      switchMap((action) =>
        this.userService.getInstagramPosts(action.max).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [getInstagramPostsSuccess({ data: res })]),
          catchError((error) => {
            return of(getInstagramPostsFailure({ error }));
          }),
        ),
      ),
    );
  });

  newsletterSubscribeEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(newsletterSubscribe),
      switchMap((action) =>
        this.userService.newsletterSubscribe(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Subscribed Successfully`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [newsletterSubscribeSuccess({ data: res })]),
          catchError((error) => {
            return of(newsletterSubscribeFailure({ error }));
          }),
        ),
      ),
    );
  });

  contactAgentEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(contactAgent),
      switchMap((action) =>
        this.userService.contactAgent(action.data).pipe(
          tap((result) => {
            if (result.success) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: result.message,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [contactAgentSuccess({ data: res })]),
          catchError((error) => {
            return of(contactAgentFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentContactQueriesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAgentContactQueries),
      switchMap((action) =>
        this.userService.getAgentContactQueries().pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [getAgentContactQueriesSuccess({ data: res })]),
          catchError((error) => {
            return of(getAgentContactQueriesFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentPortfolioEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAgentPortfolio),
      switchMap(() =>
        this.userService.getAgentPortfolio().pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [getAgentPortfolioSuccess({ data: res })]),
          catchError((error) => {
            return of(getAgentPortfolioFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateAgentPortfolioEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateAgentPortfolio),
      switchMap((action) =>
        this.userService.updateAgentPortfolio(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Agent portfolio updated successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
              scrollToTop();
            }
          }),
          mergeMap((res) => [updateAgentPortfolioSuccess({ data: res })]),
          catchError((error) => {
            return of(updateAgentPortfolioFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentPayrollSubmissionsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAgentPayrollSubmissions),
      switchMap((action) =>
        this.userService.getAgentPayrollSubmissions(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              //
            }
          }),
          mergeMap((res) => [
            getAgentPayrollSubmissionsSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getAgentPayrollSubmissionsFailure({ error }));
          }),
        ),
      ),
    );
  });

  createAgentPayrollRequestEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(createAgentPayrollRequest),
      switchMap((action) =>
        this.userService.createAgentPayrollRequest(action.data).pipe(
          tap((result) => {
            if (result) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Agent payroll request created successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
              scrollToTop();
            }
          }),
          mergeMap((res) => [createAgentPayrollRequestSuccess({ data: res })]),
          catchError((error) => {
            return of(createAgentPayrollRequestFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateAgentPayrollRequestEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateAgentPayrollRequest),
      tap(() => {
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
          data: {
            title: `Updating agent payroll request...`,
            type: 'info',
          },
          panelClass: 'info',
          duration: 5000,
          horizontalPosition: 'start',
        });
      }),
      switchMap((action) =>
        this.userService.updateAgentPayrollRequest(action.id, action.data).pipe(
          mergeMap((res) => [
            updateAgentPayrollRequestSuccess({ data: res }),
            getAgentPayrollSubmissions({ data: action.searchData }),
          ]),
          catchError((error) => {
            return of(updateAgentPayrollRequestFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentPayrollSubmissionDetailsEffect$: Observable<Action> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(getAgentPayrollSubmissionDetails),
        switchMap((action) =>
          this.userService.getAgentPayrollSubmissionDetails(action.id).pipe(
            tap((result) => {
              if (result.successful) {
                //
              }
            }),
            mergeMap((res) => [
              getAgentPayrollSubmissionDetailsSuccess({ data: res }),
            ]),
            catchError((error) => {
              return of(getAgentPayrollSubmissionDetailsFailure({ error }));
            }),
          ),
        ),
      );
    },
  );

  uploadAgentPayrollDocumentsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(uploadAgentPayrollDocuments),
      switchMap((action) =>
        this.userService.uploadAgentPayrollDocuments(action.data).pipe(
          tap((result) => {
            if (result.blobUrl) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Document uploaded successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 2000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            uploadAgentPayrollDocumentsSuccess({ data: res }),
          ]),
          catchError((error) => {
            return of(uploadAgentPayrollDocumentsFailure({ error }));
          }),
        ),
      ),
    );
  });

  deleteAgentPayrollSubmissionEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteAgentPayrollSubmission),
      switchMap((action) =>
        this.userService.deleteAgentPayrollSubmission(action.submissionId).pipe(
          tap((result) => {
            if (result.success) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Payroll submission deleted successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 3000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            deleteAgentPayrollSubmissionSuccess({ data: res }),
            getAgentPayrollSubmissions({ data: action.searchData }),
          ]),
          catchError((error) => {
            return of(deleteAgentPayrollSubmissionFailure({ error }));
          }),
        ),
      ),
    );
  });

  deleteAgentPayrollAttachmentEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteAgentPayrollAttachment),
      switchMap((action) =>
        this.userService
          .deleteAgentPayrollAttachment(
            action.attachmentId,
            action.submissionId,
          )
          .pipe(
            tap((result) => {
              if (result.success) {
                this.snackBar.openFromComponent(CustomSnackbarComponent, {
                  data: {
                    title: `Payroll attachment deleted successfully.`,
                    type: 'success',
                  },
                  panelClass: 'success',
                  duration: 3000,
                  horizontalPosition: 'start',
                });
                scrollToTop();
              }
            }),
            mergeMap((res) => [
              deleteAgentPayrollAttachmentSuccess({ data: res }),
              getAgentPayrollSubmissionDetails({ id: action.submissionId }),
            ]),
            catchError((error) => {
              return of(deleteAgentPayrollAttachmentFailure({ error }));
            }),
          ),
      ),
    );
  });

  getAgentOffMarketPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAgentOffMarketProperties),
      switchMap((action) =>
        this.userService.getAgentOffMarketProperties(action.data).pipe(
          mergeMap((res) => [
            getAgentOffMarketPropertiesSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getAgentOffMarketPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });

  getAgentOffMarketPropertyDetailsEffect$: Observable<Action> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(getAgentOffMarketPropertyDetails),
        switchMap((action) =>
          this.userService.getAgentOffMarketPropertyDetails(action.id).pipe(
            mergeMap((res) => [
              getAgentOffMarketPropertyDetailsSuccess({ data: res }),
            ]),
            catchError((error) => {
              return of(getAgentOffMarketPropertyDetailsFailure({ error }));
            }),
          ),
        ),
      );
    },
  );

  createAgentOffMarketPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(createAgentOffMarketProperty),
      switchMap((action) =>
        this.userService.createAgentOffMarketProperty(action.data).pipe(
          tap((result) => {
            if (result) {
              this.dialog.closeAll();
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Off-market property created successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 3000,
                horizontalPosition: 'start',
              });
              this.router.navigate([
                Routes.agentEditOffmarketProperty,
                result.id,
              ]);
            }
          }),
          mergeMap((res) => [
            createAgentOffMarketPropertySuccess({ data: res }),
          ]),
          catchError((error) => {
            return of(createAgentOffMarketPropertyFailure({ error }));
          }),
        ),
      ),
    );
  });

  updateAgentOffMarketPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateAgentOffMarketProperty),
      switchMap((action) =>
        this.userService.updateAgentOffMarketProperty(action.data).pipe(
          mergeMap((res) => [
            updateAgentOffMarketPropertySuccess({ data: res }),
          ]),
          catchError((error) => {
            return of(updateAgentOffMarketPropertyFailure({ error }));
          }),
        ),
      ),
    );
  });

  deleteAgentOffMarketPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteAgentOffMarketProperty),
      switchMap((action) =>
        this.userService.deleteAgentOffMarketProperty(action.id).pipe(
          mergeMap((res) => [
            deleteAgentOffMarketPropertySuccess({ data: res }),
            getAgentOffMarketProperties({ data: action.data }),
          ]),
          catchError((error) => {
            return of(deleteAgentOffMarketPropertyFailure({ error }));
          }),
        ),
      ),
    );
  });

  uploadAgentOffMarketPropertyDocumentsEffect$: Observable<Action> =
    createEffect(() => {
      return this.actions$.pipe(
        ofType(uploadAgentOffMarketPropertyDocuments),
        switchMap((action) =>
          this.userService
            .uploadAgentOffMarketPropertyDocuments(action.data)
            .pipe(
              mergeMap((res) => [
                uploadAgentOffMarketPropertyDocumentsSuccess({ data: res }),
              ]),
              catchError((error) => {
                return of(
                  uploadAgentOffMarketPropertyDocumentsFailure({ error }),
                );
              }),
            ),
        ),
      );
    });

  deleteAgentOffMarketPropertyDocumentEffect$: Observable<Action> =
    createEffect(() => {
      return this.actions$.pipe(
        ofType(deleteAgentOffMarketPropertyDocument),
        switchMap((action) =>
          this.userService
            .deleteAgentOffMarketPropertyDocument({
              propertyId: action.propertyId,
              imageId: action.documentId,
            })
            .pipe(
              mergeMap((res) => [
                deleteAgentOffMarketPropertyDocumentSuccess({ data: res }),
              ]),
              catchError((error) => {
                return of(
                  deleteAgentOffMarketPropertyDocumentFailure({ error }),
                );
              }),
            ),
        ),
      );
    });

  generateAgentOffMarketPropertyShareLinkEffect$: Observable<Action> =
    createEffect(() => {
      return this.actions$.pipe(
        ofType(generateAgentOffMarketPropertyShareLink),
        switchMap((action) =>
          this.userService
            .generateAgentOffMarketPropertyShareLink(action.propertyId)
            .pipe(
              tap((result) => {
                if (result.token) {
                  this.snackBar.openFromComponent(CustomSnackbarComponent, {
                    data: {
                      title: `Share link generated & copied to clipboard successfully.`,
                      type: 'success',
                    },
                    panelClass: 'success',
                    duration: 5000,
                    horizontalPosition: 'start',
                  });

                  this.clipboard.copy(
                    environment.webUrl + 'off-market-property/' + result.token,
                  );
                }
              }),
              mergeMap((res) => [
                generateAgentOffMarketPropertyShareLinkSuccess({ data: res }),
              ]),
              catchError((error) => {
                return of(
                  generateAgentOffMarketPropertyShareLinkFailure({ error }),
                );
              }),
            ),
        ),
      );
    });

  getSharedOffMarketPropertyEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getSharedOffMarketProperty),
      switchMap((action) =>
        this.userService.getSharedOffMarketProperty(action.token).pipe(
          mergeMap((res) => [getSharedOffMarketPropertySuccess({ data: res })]),
          catchError((error) => {
            return of(getSharedOffMarketPropertyFailure({ error }));
          }),
        ),
      ),
    );
  });

  createOrUpdateRentalListingEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(createOrUpdateRentalListing),
      switchMap((action) =>
        this.rentalService.createOrUpdateListing(action.data).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: `Rental listing created successfully.`,
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            createOrUpdateRentalListingSuccess({ data: res }),
          ]),
          catchError((error) => {
            return of(createOrUpdateRentalListingFailure({ error }));
          }),
        ),
      ),
    );
  });

  getRentalListingsEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getRentalListings),
      switchMap((action) =>
        this.rentalService.getListings(action.data).pipe(
          mergeMap((res) => [
            getRentalListingsSuccess({
              data: res,
            }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getRentalListingsFailure({ error }));
          }),
        ),
      ),
    );
  });

  getRentalListingByIdEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getRentalListingById),
      switchMap((action) =>
        this.rentalService.getListingById(action.id).pipe(
          mergeMap((res) => [getRentalListingByIdSuccess({ data: res })]),
          catchError((error) => {
            return of(getRentalListingByIdFailure({ error }));
          }),
        ),
      ),
    );
  });

  getPublicRentalListingByIdEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getPublicRentalListingById),
      switchMap((action) =>
        this.rentalService.getPublicListingById(action.id).pipe(
          mergeMap((res) => [getPublicRentalListingByIdSuccess({ data: res })]),
          catchError((error) => {
            return of(getPublicRentalListingByIdFailure({ error }));
          }),
        ),
      ),
    );
  });

  submitRentalForApprovalEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(submitRentalForApproval),
      switchMap((action) =>
        this.rentalService.submitForApproval(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: 'Rental listing submitted for approval.',
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            submitRentalForApprovalSuccess({ data: res, id: action.id }),
          ]),
          catchError((error) => {
            return of(submitRentalForApprovalFailure({ error }));
          }),
        ),
      ),
    );
  });

  deleteRentalListingEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteRentalListing),
      switchMap((action) =>
        this.rentalService.deleteListing(action.id).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: {
                  title: 'Rental listing deleted successfully.',
                  type: 'success',
                },
                panelClass: 'success',
                duration: 5000,
                horizontalPosition: 'start',
              });
            }
          }),
          mergeMap((res) => [
            deleteRentalListingSuccess({ data: res, id: action.id }),
          ]),
          catchError((error) => {
            return of(deleteRentalListingFailure({ error }));
          }),
        ),
      ),
    );
  });

  searchRentalPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(searchRentalProperties),
      switchMap((action) =>
        this.rentalService.searchProperties(action.data).pipe(
          mergeMap((res) => [
            searchRentalPropertiesSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(searchRentalPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });

  getRentalMapMarkersEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getRentalMapMarkers),
      switchMap((action) =>
        this.rentalService.getRentalMapMarkers(action.data).pipe(
          mergeMap((res) => [getRentalMapMarkersSuccess({ data: res })]),
          catchError((error) => {
            return of(getRentalMapMarkersFailure({ error }));
          }),
        ),
      ),
    );
  });

  getArisMarketedPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getArisMarketedProperties),
      switchMap((action) =>
        this.userService.getArisMarketedProperties(action.data).pipe(
          mergeMap((res) => [
            getArisMarketedPropertiesSuccess({
              data: res.result as MarketedPropertyListing[],
            }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getArisMarketedPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });

  getArisMarketedMapPropertiesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getArisMarketedMapProperties),
      switchMap((action) =>
        this.userService.getArisMarketedMapProperties(action.data).pipe(
          mergeMap((res) => [
            getArisMarketedMapPropertiesSuccess({
              data: (res as MarketedPropertyListing[]) ?? [],
            }),
          ]),
          catchError((error) => {
            return of(getArisMarketedMapPropertiesFailure({ error }));
          }),
        ),
      ),
    );
  });
}
